import styled from 'styled-components';

export const Title = styled.div`
  width: 100%;
  height: 50px;

  border-bottom: 1px solid #bbb;

  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 24px;
  font-weight: 600;
`;

export const Body = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;

  width: 100%;
  height: 100%;
  min-height: 150px;

  form {
    width: 100%;
    height: 100%;

    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
`;

export const FormRow = styled.div`
  width: 100%;
  height: 100%;

  margin: 20px 0;
  padding: 0 15px;

  display: flex;
  align-items: center;
  justify-content: space-between;

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: center;
    justify-content: center;

    margin-bottom: 0;
  }
`;

export const InputHolder = styled.div`
  width: 100%;
  height: 100%;

  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-end;

  margin: 0 10px;

  &:first-of-type {
    margin-left: 0px;
  }
  &:last-of-type {
    margin-right: 0px;
  }

  .checkboxHolder {
    height: 44px;
    justify-content: center;
    align-items: flex-start;
    span {
      font-size: 1.4rem;
    }
    input[type='checkbox'] {
      transform: scale(1.2);
      margin-right: 10px;
    }
  }

  label {
    font-size: 1.15rem;
    margin-bottom: 3px;
  }

  @media (max-width: 768px) {
    width: 100% !important;
    margin: 10px 0;
  }
`;

export const Divisor = styled.hr`
  width: 80%;
  height: 1px;
  margin: 20px 0;

  box-shadow: none;
  border: none;
  background: #bbb;
`;

export const WarnCondicao = styled.span`
  width: 100%;
  height: 100px;

  display: flex;
  justify-content: center;
  align-items: center;

  font-size: 14px;
`;

export const ConfirmButton = styled.button`
  width: 200px;
  height: 50px;

  background-color: var(--main-color);
  color: var(--text-color-1);
  border: none;
  border-radius: 30px;
`;

export const ModalRoot = styled.div`
  width: 100%;
  height: 100%;
`;
